"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalize = void 0;
const capitalize = (value) => {
    if (!value || typeof value !== 'string') {
        return value;
    }
    return `${value[0].toUpperCase()}${value.slice(1)}`;
};
exports.capitalize = capitalize;
//# sourceMappingURL=capitalize.js.map